// Quanto falta para o PIX online vencer, a partir do `expires_at` que o
// servidor devolve na criação (o prazo vem da configuração da loja, de 1 a
// 1440 min). Até 27/10/2026 a janela contava 10 minutos fixos e recomeçava do
// 10:00 quando o mesmo PIX pendente voltava (achado 222).

export const PIX_EXPIRACAO_PADRAO_MIN = 10;

/** Segundos até `expiresAt` (0 se já venceu); sem data válida, os 10 min de sempre. */
export function segundosAteExpirar(expiresAt, agora = Date.now()) {
  const fim = expiresAt ? Date.parse(expiresAt) : NaN;
  if (Number.isNaN(fim)) return PIX_EXPIRACAO_PADRAO_MIN * 60;
  return Math.max(0, Math.round((fim - agora) / 1000));
}
